module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/align-left-b0a67bd0eef1b637014f27e1bb0ca74b.svg";